<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Thông tin bộ phụ kiện tặng kèm'">
          <template v-slot:preview>
            <b-form ref="form" lazy-validation class="row">
              <!-- Input session -->
              <b-container class="bv-example-row">
                <div>
                  <p class="text-dark font-size-h5 font-weight-bold">
                    Bộ phụ kiện tặng kèm
                  </p>
                </div>
                <b-row>
                  <b-col cols="3">
                    <b-form-group id="input-group-name">
                      <label for="input-code">Tên bộ phụ kiện:</label>
                      <b-form-input
                        size="sm"
                        id="input-name"
                        v-model="name"
                        placeholder="Nhập tên"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-code">
                      <label for="input-code">Mã bộ phụ kiện:</label>
                      <b-form-input
                        size="sm"
                        id="input-code"
                        v-model="code"
                        placeholder="Nhập mã"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-company">
                      <label for="input-company">Doanh nghiệp áp dụng:</label>
                      <b-form-select
                        id="input-company"
                        size="sm"
                        v-model="selectedCompanyId"
                        :options="companies"
                        value-field="id"
                        text-field="name"
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >-- Chọn doanh nghiệp --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                      <div
                        v-if="submitAttempted && !selectedCompanyId"
                        class="text-danger mt-1"
                      >
                        Vui lòng chọn doanh nghiệp
                      </div>
                    </b-form-group>

                    <b-form-group id="input-group-start-date">
                      <label for="input-start-date">Ngày bắt đầu:</label>
                      <date-picker
                        placeholder="Từ ngày"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="startDate"
                      ></date-picker>
                    </b-form-group>

                    <b-form-group id="input-group-end-date">
                      <label for="input-end-date">Ngày kết thúc:</label>
                      <date-picker
                        placeholder="Đến ngày"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="endDate"
                      ></date-picker>
                    </b-form-group>
                  </b-col>

                  <b-col cols="5">
                    <label style="font-weight: 600" for="input-description"
                      >Mô tả:</label
                    >
                    <b-form-textarea
                      id="textarea-description"
                      v-model="description"
                      placeholder="Nhập mô tả"
                      rows="13"
                    ></b-form-textarea>
                  </b-col>
                  <b-col cols="2">
                    <label style="font-weight: 600" for="input-status"
                      >Trạng thái:</label
                    >
                    <b-form-select
                      size="sm"
                      id="input-3"
                      v-model="selectedStatus"
                      :options="listStatus"
                      required
                      value-field="id"
                      text-field="name"
                      disabled-field="notEnabled"
                    ></b-form-select>
                  </b-col>
                  <b-col cols="2">
                    <label style="font-weight: 600" for="input-status"
                      >Kênh áp dụng:</label
                    >
                    <b-form-select
                      size="sm"
                      id="input-3"
                      v-model="selectedAppliedChannel"
                      :options="listAppliedChannel"
                      required
                      value-field="id"
                      text-field="name"
                      disabled-field="notEnabled"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-form-group
                    id="input-group-search"
                    class="col-md-12 mt-4 pr-0"
                  >
                    <label for="input-code">Tìm sản phẩm quà tặng:</label>
                    <b-col md="12" class="row pr-0">
                      <b-col md="6" class="p-0">
                        <vue-autosuggest
                          v-model="searchProductAccessory"
                          :suggestions="filteredOptionsProduct"
                          @selected="onSelectedProduct"
                          :limit="10"
                          @input="onInputChangeProduct"
                          :input-props="{
                            id: 'autosuggest__input',
                            placeholder: 'Nhập tên sản phẩm',
                            style: 'border-radius:0px!important',
                          }"
                          :should-render-suggestions="
                            (size, loading) => size >= 0 && !loading
                          "
                        >
                          <template slot-scope="{ suggestion }">
                            <div>{{ suggestion.item.productName }}</div>
                          </template>
                        </vue-autosuggest>
                      </b-col>
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeSearch"
                          :options="listTypeSearch"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="debounceInput"
                        ></b-form-select>
                      </b-col>
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeOfProduct"
                          :options="listTypeOfProduct"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="debounceInput"
                        ></b-form-select>
                      </b-col>
                      <b-col md="2" class="pr-0">
                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            class="btn btn-secondary font-weight-bolder btn-sm"
                            :disabled="isProcessing"
                            @click="showModalImportProduct"
                          >
                            <i
                              style="font-size: 1rem"
                              class="far fa-file-excel"
                            ></i
                            >Nhập SP từ excel
                          </button>
                        </div>
                      </b-col>
                    </b-col>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-col cols="12" md="12">
                    <div>
                      <!-- <table
                        class="table table-bordered table-vertical-center table-hover"
                      >
                        <thead>
                          <tr>
                            <th class="name headerTable">Mã sp</th>
                            <th class="value headerTable">Tên sp</th>
                            <th class="code headerTable">Giá vốn</th>
                            <th class="code headerTable">Giá bán</th>
                            <th class="code headerTable">Giá thu lại</th>
                            <th></th>
                          </tr>
                        </thead>

                        <tbody
                          v-for="(item, index) in accessoryItems"
                          :key="index"
                        >
                          <AccessoryItem
                            v-bind:productItem="item"
                            v-bind:type="accessoryType"
                            v-on:deleteItem="deleteItemInArray"
                            v-on:update="updateItem"
                            v-bind:index="index"
                          />
                        </tbody>
                      </table> -->
                      <b-table
                        class="table-bordered table-hover col-md-12"
                        :fields="fieldProduct"
                        :items="accessoryItems"
                        v-if="renderComponent"
                        :per-page="10"
                        :current-page="currentPageTable"
                        id="my-table-product"
                      >
                        <template v-slot:cell(importPrice)="row">
                          <b-input
                            type="text"
                            size="sm"
                            class="input-style text-right"
                            v-model="row.item.importPrice"
                            v-mask="mask"
                            @change="forceRerender"
                          ></b-input>
                        </template>
                        <template v-slot:cell(originalPrice)="row">
                          <span class="text-right">{{
                            formatMoney(row.item.originalPrice)
                          }}</span>
                        </template>
                        <template v-slot:cell(sellingPrice)="row">
                          <span class="text-right">{{
                            formatMoney(row.item.sellingPrice)
                          }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-danger"
                            :style="isProcessing ? 'pointer-events: none' : null"
                            :disabled="isProcessing"
                            @click="deleteItemInArray(row.item.productId)"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </b-table>
                      <b-pagination
                        v-show="accessoryItems.length > 10"
                        v-model="currentPageTable"
                        :total-rows="rowsTable"
                        :per-page="10"
                        aria-controls="my-table-product"
                        align="right"
                      ></b-pagination>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4"></b-col>
                </b-row>

                <b-row v-if="allowWarrantyRegistration">
                  <b-form-group
                    id="input-group-search"
                    class="col-md-12 mt-4 pr-0"
                  >
                    <label for="input-code"
                      >Tìm sản phẩm/ nhóm sản phẩm áp dụng:</label
                    >
                    <b-col md="12" class="row pr-0">
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeSearchForApply"
                          :options="listTypeSearchForApply"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="onChangeTypeSearchForApply"
                        ></b-form-select>
                      </b-col>
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeOfProductForApply"
                          :options="listTypeOfProductForApply"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="debounceInputForApply"
                        ></b-form-select>
                      </b-col>
                      <b-col md="6" class="p-0">
                        <vue-autosuggest
                          v-model="searchProductForApply"
                          :suggestions="filteredOptionsProductForApply"
                          @selected="onSelectedProductForApply"
                          :limit="10"
                          @input="onInputChangeProductForApply"
                          :input-props="{
                            id: 'autosuggest__input',
                            placeholder: 'Nhập tên sản phẩm',
                            style: 'border-radius:0px!important',
                          }"
                          :should-render-suggestions="
                            (size, loading) => size >= 0 && !loading
                          "
                        >
                          <template slot-scope="{ suggestion }">
                            <div>{{ suggestion?.item?.name }}</div>
                          </template>
                        </vue-autosuggest>
                      </b-col>

                      <b-col md="2" class="pr-0">
                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            class="btn btn-secondary font-weight-bolder btn-sm"
                            :disabled="isProcessing"
                            @click="showModalImportProductForApply"
                          >
                            <i
                              style="font-size: 1rem"
                              class="far fa-file-excel"
                            ></i
                            >Nhập SP từ excel
                          </button>
                        </div>
                      </b-col>
                    </b-col>
                  </b-form-group>
                </b-row>
                <b-row v-if="allowWarrantyRegistration">
                  <b-col cols="12" md="12">
                    <div>
                      <b-table
                        id="my-table-main"
                        class="table-bordered table-hover col-md-12"
                        :fields="fieldsApply"
                        :items="accessoryProductApplyItems"
                        v-if="renderComponent"
                        :per-page="10"
                        :current-page="currentPageMain"
                      >
                        <template v-slot:cell(type)="row">
                          <span
                            v-if="
                              row.item?.type ===
                              ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
                            "
                            >Nhóm sản phẩm</span
                          >
                          <span
                            v-if="
                              row.item?.type ===
                              ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT
                            "
                            >Sản phẩm</span
                          >
                        </template>
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-danger"
                            :style="isProcessing ? 'pointer-events: none' : null"
                            :disabled="isProcessing"
                            @click="showDeleteProductApplyAlert(row.item)"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </b-table>
                      <b-pagination
                        v-show="accessoryProductApplyItems?.length > 10"
                        v-model="currentPageMain"
                        :total-rows="rowsMain"
                        :per-page="10"
                        aria-controls="my-table-main"
                        align="right"
                      ></b-pagination>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4"></b-col>
                </b-row>

                <div class="separator separator-dashed my-5"></div>

                <div>
                  <p class="text-dark font-size-h5 font-weight-bold">
                    Bộ phụ kiện cấu hình cho
                  </p>
                </div>

                <b-row>
                  <b-col md-4>
                    <b-form-group
                      id="form-group-color"
                      label-for="input-color"
                      label="Danh mục"
                    >
                      <b-input-group>
                        <vue-multi-select
                          style="margin-bottom: 2rem"
                          v-model="selectedCategory"
                          :options="categories"
                          placeholder="Chọn danh mục"
                          option-label="name"
                        ></vue-multi-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col></b-col>
                  <b-col></b-col>
                  <b-col></b-col>
                </b-row>
                <b-row>
                  <b-form-group id="input-group-search" class="col-md-12 pr-0">
                    <label for="input-code">Tìm sản phẩm:</label>
                    <b-col md="12" class="row pr-0">
                      <b-col md="6" class="p-0">
                        <vue-autosuggest
                          v-model="searchProductFor"
                          :suggestions="filteredOptionsProductFor"
                          @selected="onSelectedProductFor"
                          :limit="10"
                          @input="onInputChangeProductFor"
                          :input-props="{
                            id: 'autosuggest__input',
                            placeholder: 'Nhập tên sản phẩm',
                            style: 'border-radius:0px!important',
                          }"
                          :should-render-suggestions="
                            (size, loading) => size >= 0 && !loading
                          "
                        >
                          <template slot-scope="{ suggestion }">
                            <div>{{ suggestion.item.productName }}</div>
                          </template>
                        </vue-autosuggest>
                      </b-col>
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeSearchFor"
                          :options="listTypeSearch"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="debounceInputFor"
                        ></b-form-select>
                      </b-col>
                      <b-col md="2" class="p-0">
                        <b-form-select
                          id="select-product"
                          v-model="selectTypeOfProductFor"
                          :options="listTypeOfProduct"
                          size="sm"
                          value-field="id"
                          text-field="name"
                          disabled-field="notEnabled"
                          @change="debounceInputFor"
                        ></b-form-select>
                      </b-col>
                      <b-col md="2" class="pr-0">
                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            class="btn btn-secondary font-weight-bolder btn-sm"
                            :disabled="isProcessing"
                            @click="showModalImportProductFor"
                          >
                            <i
                              style="font-size: 1rem"
                              class="far fa-file-excel"
                            ></i
                            >Nhập SP từ excel
                          </button>
                        </div>
                      </b-col>
                    </b-col>
                  </b-form-group>
                </b-row>

                <b-row>
                  <b-col cols="12" md="8">
                    <div>
                      <b-table
                        class="table-bordered table-hover col-md-12"
                        :fields="fields"
                        :items="accessoryProductItems"
                        :per-page="10"
                        :current-page="currentPageMain"
                        id="my-table-main"
                      >
                        <template v-slot:cell(originalPrice)="row">
                          <span class="text-right">{{
                            formatMoney(row.item.originalPrice)
                          }}</span>
                        </template>
                        <template v-slot:cell(sellingPrice)="row">
                          <span class="text-right">{{
                            formatMoney(row.item.sellingPrice)
                          }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                          <v-icon
                            small
                            class="text-danger"
                            :style="isProcessing ? 'pointer-events: none' : null"
                            :disabled="isProcessing"
                            @click="showDeleteAlert(row.item)"
                            v-b-tooltip
                            title="Xóa"
                            >mdi-delete</v-icon
                          >
                        </template>
                      </b-table>
                      <b-pagination
                        v-show="accessoryProductItems.length > 10"
                        v-model="currentPageMain"
                        :total-rows="rowsMain"
                        :per-page="10"
                        aria-controls="my-table-main"
                        align="right"
                      ></b-pagination>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4"></b-col>
                </b-row>
              </b-container>
            </b-form>
            <b-modal
              ref="import-product-modal"
              hide-footer
              title="Thêm sản phẩm từ Excel"
              id="modal-prevent-closing"
              size="lg"
            >
              <b-row>
                <b-col>
                  <div class="form-group">
                    <span>
                      <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                      đúng format, hoặc có thể tải ở
                      <a :href="urlExcel">đây</a>
                    </span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span> <b>Bước 2:</b> Tiến hành Import </span>
                  <div style="padding-top: 15px">
                    <b-form-file
                      placeholder="Hãy chọn một tập tin"
                      @change="selectFile"
                      v-model="file"
                      ref="file-input"
                      class="mb-2"
                    ></b-form-file>
                  </div>
                </b-col>
              </b-row>
              <b-container
                class="mt-4 pl-0 pr-0"
                v-show="importItems.length > 0"
              >
                <h5>
                  Danh sách sản phẩm từ file excel( Tổng:
                  {{ importItems.length }} sản phẩm)
                </h5>
                <b-table
                  id="my-table"
                  class="myTable"
                  responsive
                  bordered
                  hover
                  :fields="fieldImport"
                  :items="importItems"
                  :per-page="10"
                  :current-page="currentPage"
                >
                  <template v-slot:cell(originalPrice)="row">
                    <div style="text-align: end">
                      <span v-text="formatMoney(row.item.originalPrice)"></span>
                    </div>
                  </template>

                  <template v-slot:cell(sellingPrice)="row">
                    <div style="text-align: end">
                      <span v-text="formatMoney(row.item.sellingPrice)"></span>
                    </div>
                  </template>
                </b-table>
                <b-pagination
                  v-show="importItems.length > 10"
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="10"
                  aria-controls="my-table"
                ></b-pagination>
              </b-container>
              <SaveButton
                type="button"
                :button-style="{
                  fontWeight: '600',
                  minWidth: '70px',
                  whiteSpace: 'nowrap',
                }"
                :is-busy="isSubmitting('importAccessory')"
                @click="validData"
                >Lưu</SaveButton
              >
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                :disabled="isSubmitting('importAccessory')"
                @click="hideModalImportProduct"
                >Hủy</b-button
              >
            </b-modal>
            <b-modal
              ref="import-product-for-modal"
              hide-footer
              title="Thêm sản phẩm từ Excel"
              id="modal-prevent-closing"
              size="lg"
            >
              <b-row>
                <b-col>
                  <div class="form-group">
                    <span>
                      <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                      đúng format, hoặc có thể tải ở
                      <a :href="urlExcelFor">đây</a>
                    </span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span> <b>Bước 2:</b> Tiến hành Import </span>
                  <div style="padding-top: 15px">
                    <b-form-file
                      placeholder="Hãy chọn một tập tin"
                      @change="selectFileFor"
                      v-model="fileFor"
                      ref="file-input"
                      class="mb-2"
                    ></b-form-file>
                  </div>
                </b-col>
              </b-row>
              <b-container
                class="mt-4 pl-0 pr-0"
                v-show="importItemFor.length > 0"
              >
                <h5>
                  Danh sách sản phẩm từ file excel( Tổng:
                  {{ importItemFor.length }} sản phẩm)
                </h5>
                <b-table
                  id="my-table"
                  class="myTable"
                  responsive
                  bordered
                  hover
                  :fields="fieldImportFor"
                  :items="importItemFor"
                  :per-page="10"
                  :current-page="currentPageFor"
                >
                  <template v-slot:cell(originalPrice)="row">
                    <div style="text-align: end">
                      <span v-text="formatMoney(row.item.originalPrice)"></span>
                    </div>
                  </template>

                  <template v-slot:cell(sellingPrice)="row">
                    <div style="text-align: end">
                      <span v-text="formatMoney(row.item.sellingPrice)"></span>
                    </div>
                  </template>
                  <template v-slot:cell(returnPrice)="row">
                    <div style="text-align: end">
                      <span v-text="formatMoney(row.item.returnPrice)"></span>
                    </div>
                  </template>
                </b-table>
                <b-pagination
                  v-show="importItemFor.length > 10"
                  v-model="currentPageFor"
                  :total-rows="rowsFor"
                  :per-page="10"
                  aria-controls="my-table"
                ></b-pagination>
              </b-container>
              <SaveButton
                type="button"
                :button-style="{
                  fontWeight: '600',
                  minWidth: '70px',
                  whiteSpace: 'nowrap',
                }"
                :is-busy="isSubmitting('importFor')"
                @click="validDataFor"
                >Lưu</SaveButton
              >
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                :disabled="isSubmitting('importFor')"
                @click="hideModalImportProductFor"
                >Hủy</b-button
              >
            </b-modal>
            <b-modal
              ref="import-product-for-apply-modal"
              hide-footer
              title="Thêm sản phẩm/ nhóm sản phẩm từ Excel"
              id="modal-prevent-closing"
              size="lg"
            >
              <b-row>
                <b-col>
                  <div class="form-group">
                    <span>
                      <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                      đúng format, hoặc có thể tải ở
                      <a :href="urlExcelForApply">đây</a>
                    </span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span> <b>Bước 2:</b> Tiến hành Import </span>
                  <div style="padding-top: 15px">
                    <b-form-file
                      placeholder="Hãy chọn một tập tin"
                      @change="selectFileForApply"
                      v-model="file"
                      ref="file-input"
                      class="mb-2"
                    ></b-form-file>
                  </div>
                </b-col>
              </b-row>
              <b-container class="mt-4 pl-0 pr-0" v-show="rowsApply > 0">
                <h5>
                  Danh sách sản phẩm từ file excel( Tổng:
                  {{ rowsApply }} sản phẩm)
                </h5>
                <b-table
                  id="my-table"
                  class="myTable"
                  responsive
                  bordered
                  hover
                  :fields="fieldsApply"
                  :items="importItemsForApply"
                  :per-page="10"
                  :current-page="currentPage"
                >
                  <template v-slot:cell(type)="row">
                    <span
                      v-if="
                        row.item.type ===
                        ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT
                      "
                      >Sản phẩm</span
                    >
                    <span
                      v-if="
                        row.item.type ===
                        ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
                      "
                      >Nhóm sản phẩm</span
                    >
                  </template>
                </b-table>
                <b-pagination
                  v-show="rowsApply > pageSize"
                  v-model="currentPage"
                  :total-rows="rowsApply"
                  :per-page="10"
                  aria-controls="my-table"
                  align="right"
                ></b-pagination>
              </b-container>
              <SaveButton
                type="button"
                :button-style="{
                  fontWeight: '600',
                  minWidth: '70px',
                  whiteSpace: 'nowrap',
                }"
                :is-busy="isSubmitting('importForApply')"
                @click="validDataForApply"
                >Lưu</SaveButton
              >
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                :disabled="isSubmitting('importForApply')"
                @click="hideModalImportProductForApply"
                >Hủy</b-button
              >
            </b-modal>
          </template>
          <template v-slot:foot>
            <!-- <b-col lg="4" class="pb-2"> -->
            <b-container class="bv-example-row">
              <b-row>
                <SaveButton
                  type="button"
                  :button-style="{
                    fontWeight: '600',
                    minWidth: '70px',
                    whiteSpace: 'nowrap',
                  }"
                  :is-busy="isSubmitting('save')"
                  @click="onSubmit"
                  >Lưu</SaveButton
                >
                <router-link
                  to="/accessories"
                  tag="button"
                  :style="isProcessing ? 'pointer-events: none' : null"
                >
                  <b-button
                    style="margin-left: 10px; font-weight: 600; width: 70px"
                    variant="secondary"
                    size="sm"
                    :disabled="isProcessing"
                    >Hủy</b-button
                  >
                </router-link>
              </b-row>
            </b-container>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>
<style>
.multi-select-wrapper {
  flex: 1 1 auto;
}

.center-label label {
  margin-bottom: 0px;
}

.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
// Import datePicker component
import datePicker from 'vue-bootstrap-datetimepicker';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import jQuery from 'jquery';
// Using font-awesome 5 icons
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import moment from 'moment';
import xlsx from 'xlsx';

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle',
  },
});
import VueMultiSelect from 'vue-simple-multi-select';
import decounce from 'debounce';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';
import {
  currencyMask,
  isFeatureActive,
  unMaskPrice,
  pickProgramCompanyId,
  getProgramCompanies,
} from '@/utils/common';
import _ from 'lodash';
import {
  ACCESSORY_PRODUCT_SEARCH_TYPE,
  ACCESSORY_PRODUCT_FOR_APPLY_TYPE,
  FEATURE_FLAG,
  COMPANY_CODE,
} from '@/utils/enum';
import {
  TIME_TRIGGER,
  URL_IMPORT_PRODUCT_ACCESSORY,
  URL_IMPORT_PRODUCT_FOR_ACCESSORY,
  URL_IMPORT_REWARD_PRODUCT_CATEGORY,
  PRODUCT_TYPE_SEARCH,
} from '@/utils/constants';
import {
  ACCESSORY_GROUP_APPLIED_CHANNEL,
  ACCESSORY_GROUP_APPLIED_CHANNEL_NAME,
} from '@/view/pages/accessories/constants';

export default {
  data() {
    return {
      pageSize: 10,
      ACCESSORY_PRODUCT_SEARCH_TYPE,
      ACCESSORY_PRODUCT_FOR_APPLY_TYPE,
      selectedAppliedChannel: ACCESSORY_GROUP_APPLIED_CHANNEL.OFFLINE,
      listAppliedChannel: Object.values(ACCESSORY_GROUP_APPLIED_CHANNEL).map(
        (key) => ({
          id: key,
          name: ACCESSORY_GROUP_APPLIED_CHANNEL_NAME[key],
        }),
      ),
      selectedCategory: [],
      companies: [],
      companiesRequest: null,
      selectedCompanyId: null,
      submitAttempted: false,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      startDate: '',
      endDate: '',
      accessoryType: 1,
      fields: [
        {
          key: 'productCode',
          label: 'Mã',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'productName',
          label: 'Tên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        { key: 'actions', label: '' },
      ],
      listProductFor: [],
      filteredOptionsProductFor: [],
      optionsProductFor: [
        {
          data: [],
        },
      ],
      optionsProductForApply: [
        {
          data: [],
        },
      ],
      listProduct: [],
      filteredOptionsProduct: [],
      optionsProduct: [
        {
          data: [],
        },
      ],
      code: '',
      name: '',
      description: '',
      searchProductAccessory: '',
      accessoryItems: [],
      accessoryProductItems: [],
      searchProductFor: '',
      categories: '',
      stores: '',
      listStatus: [
        {
          id: 1,
          name: 'Hoạt động',
        },
        {
          id: 2,
          name: 'Đã khóa',
        },
      ],
      selectedStatus: 1,
      isSearching: false,
      listTypeSearchForApply: [
        {
          id: 1,
          name: 'Sản phẩm IMEI',
        },
        // {
        //   id: 2,
        //   name: "Sản phẩm",
        // },
        {
          id: 3,
          name: "Nhóm sản phẩm",
        },
      ],
      selectTypeSearchForApply: 1,
      listTypeOfProductForApply: PRODUCT_TYPE_SEARCH,
      selectTypeOfProductForApply: 0,
      filteredOptionsProductForApply: [],
      searchProductForApply: '',
      accessoryProductApplyItems: [],
      fieldsApply: [
        {
          key: 'type',
          label: 'Loại',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '30%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '45%',
          },
          tdClass: 'text-left',
        },

        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
        },
      ],
      listTypeSearch: [
        {
          id: 1,
          name: 'Sản phẩm IMEI',
        },
        {
          id: 2,
          name: 'Sản phẩm',
        },
      ],
      selectTypeSearch: 2,
      listTypeOfProduct: [
        {
          id: 0,
          name: 'Tất cả sản phẩm',
        },
        {
          id: 1,
          name: 'Sản phẩm cha',
        },
        {
          id: 2,
          name: 'Sản phẩm con',
        },
        {
          id: 3,
          name: 'Sản phẩm độc lập',
        },
        {
          id: 4,
          name: 'Sản phẩm cha + độc lập',
        },
        {
          id: 5,
          name: 'Sản phẩm con + độc lập',
        },
      ],
      selectTypeOfProduct: 0,
      selectTypeSearchFor: 1,
      selectTypeOfProductFor: 0,
      importItems: [],
      file: null,
      excellist: [],
      progress: 0,
      uploading: false,
      fieldImport: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
        },
        {
          key: 'originalPrice',
          label: 'Giá vốn',
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
        },
        {
          key: 'returnPrice',
          label: 'Giá thu lại',
        },
      ],
      currentPage: 1,
      importItemFor: [],
      importItemsForApply: [],
      fileFor: null,
      excellistFor: [],
      currentPageFor: 1,
      fieldImportFor: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
        },
        {
          key: 'originalPrice',
          label: 'Giá vốn',
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
        },
      ],
      urlExcel: URL_IMPORT_PRODUCT_ACCESSORY,
      urlExcelFor: URL_IMPORT_PRODUCT_FOR_ACCESSORY,
      urlExcelForApply: URL_IMPORT_REWARD_PRODUCT_CATEGORY,
      currentPageMain: 1,
      currentPageTable: 1,
      fieldProduct: [
        {
          key: 'productCode',
          label: 'Mã SP',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'productName',
          label: 'Tên SP',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'originalPrice',
          label: 'Giá vốn',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'importPrice',
          label: 'Giá thu lại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        { key: 'actions', label: '' },
      ],
      renderComponent: true,
      mask: currencyMask,
      allowWarrantyRegistration: false,
    };
  },
  mixins: [submitLock],
  components: {
    SaveButton,
    KTCodePreview,
    // AccessoryItem,
    datePicker,
    VueMultiSelect,
  },
  computed: {
    // Khoá cả nhóm control khi đang lưu hoặc đang import từ Excel
    isProcessing() {
      return (
        this.isSubmitting('save') ||
        this.isSubmitting('importAccessory') ||
        this.isSubmitting('importFor') ||
        this.isSubmitting('importForApply')
      );
    },
    rows() {
      return this.importItems.length;
    },
    rowsFor() {
      return this.importItemFor.length;
    },
    rowsTable() {
      return this.accessoryItems.length;
    },
    rowsMain() {
      return this.accessoryProductItems.length;
    },
    rowsApply() {
      return this.importItemsForApply.length;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Bộ phụ kiện tặng kèm', route: '/accessories' },
      {
        title: 'Thêm mới bộ phụ kiện tặng kèm',
        route: '/accessories/add-accessory',
      },
    ]);
    const copyId = this.$route.query.id;
    if (copyId) {
      // Sao chép: lấy đúng tập pháp nhân của bản ghi gốc, không dùng mặc định
      this.getInfoById(copyId);
    } else {
      this.presetDefaultCompany();
    }
  },
  async created() {
    //this.fetchProduct();
    this.getCategories();
    this.allowWarrantyRegistration = await isFeatureActive(
      FEATURE_FLAG.WARRANTY_REGISTRATION,
    );
  },
  methods: {
    fetchCompany: function () {
      // Cache lời gọi để luồng sao chép nạp xong danh sách rồi mới map companyIds của bản ghi
      if (!this.companiesRequest) {
        ApiService.setHeader();
        this.companiesRequest = ApiService.get('company')
          .then((response) => {
            // Chỉ DDV và VDD được khai chương trình
            this.companies = getProgramCompanies(
              (response.data.data || []).map((company) => ({
                id: company.id,
                name: company.name,
              })),
            );
            return this.companies;
          })
          .catch(() => {
            // Không chặn việc nạp bản ghi khi API doanh nghiệp lỗi; bỏ cache để lần sau thử lại
            this.companiesRequest = null;
            this.makeToastFaile('Không tải được danh sách doanh nghiệp!');
            return [];
          });
      }
      return this.companiesRequest;
    },
    presetDefaultCompany: async function () {
      await this.fetchCompany();
      // Mặc định bộ phụ kiện thuộc DDV, người dùng có thể đổi sang pháp nhân khác
      const defaultCompany = this.companies.find(
        (company) => company.id === COMPANY_CODE.DDV,
      );
      if (defaultCompany && !this.selectedCompanyId) {
        this.selectedCompanyId = defaultCompany.id;
      }
    },
    onChangeTypeSearchForApply() {
      this.selectTypeOfProductForApply = 0;
      if (
        this.selectTypeSearchForApply ===
        ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
      ) {
        this.listTypeOfProductForApply = [
          {
            id: 0,
            name: 'Tất cả nhóm sản phẩm',
          },
          {
            id: 1,
            name: 'Nhóm sản phẩm cha',
          },
          {
            id: 2,
            name: 'Nhóm sản phẩm con',
          },
        ];
      } else {
        this.listTypeOfProductForApply = [
          {
            id: 0,
            name: 'Tất cả sản phẩm',
          },
          {
            id: 1,
            name: 'Sản phẩm cha',
          },
          {
            id: 2,
            name: 'Sản phẩm con',
          },
          {
            id: 3,
            name: 'Sản phẩm độc lập',
          },
          {
            id: 4,
            name: 'Sản phẩm cha + độc lập',
          },
          {
            id: 5,
            name: 'Sản phẩm con + độc lập',
          },
        ];
      }
      this.debounceInputForApply();
    },
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    getCategories() {
      ApiService.setHeader();
      ApiService.query('category')
        .then(({ data }) => {
          if (data.status === 1) {
            this.categories = data.data.list_caterogy;
          } else {
            this.makeToastFaile('Tải dữ liệu thất bại!');
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    updateItem(item) {
      this.accessoryItems.forEach((element, index) => {
        if (element.productId === item.productId) {
          this.accessoryItems[index].importPrice = item.importPrice;
        }
      });
    },
    formatMoney(number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa sản phẩm!',
        text: 'Bạn có chắc muốn xóa sản phẩm này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          for (let i = 0; i < this.accessoryProductItems.length; i++) {
            if (this.accessoryProductItems[i].productId === item.productId) {
              this.accessoryProductItems.splice(i, 1);
            }
          }
        }
      });
    },
    deleteItemInArray(productId) {
      for (var i = 0; i < this.accessoryItems.length; i++) {
        if (this.accessoryItems[i].productId === productId) {
          this.accessoryItems.splice(i, 1);
        }
      }
    },
    fetchProduct(textSearch) {
      this.listProduct = [];
      this.optionsProduct[0].data = [];
      ApiService.setHeader();
      ApiService.get(
        `productSearch/search-by-type?searchProduct=${textSearch}&typeSearch=${this.selectTypeSearch}&typeOfProduct=${this.selectTypeOfProduct}`,
      ).then(({ data }) => {
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProduct[0].data.push(element);
        });
        this.filteredOptionsProduct = [
          {
            data: this.optionsProduct[0].data,
          },
        ];
        if (textSearch !== this.searchProductAccessory) {
          let nextTextSearch = this.searchProductAccessory;
          this.fetchProduct(nextTextSearch);
        }
      });
    },
    fetchProductFor(textSearch) {
      this.listProduct = [];
      this.optionsProductFor[0].data = [];
      ApiService.setHeader();
      ApiService.get(
        `productSearch/search-by-type?searchProduct=${textSearch}&typeSearch=${this.selectTypeSearchFor}&typeOfProduct=${this.selectTypeOfProductFor}`,
      ).then(({ data }) => {
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProductFor[0].data.push(element);
        });
        this.filteredOptionsProductFor = [
          {
            data: this.optionsProductFor[0].data,
          },
        ];
        if (textSearch !== this.searchProductFor) {
          let nextTextSearch = this.searchProductFor;
          this.fetchProduct(nextTextSearch);
        }
      });
    },
    fetchProductForApply(textSearch) {
      this.listProduct = [];
      this.optionsProductForApply[0].data = [];

      ApiService.setHeader();
      ApiService.get(
        `productSearch/search-by-product-category?searchProduct=${textSearch}&typeSearch=${this.selectTypeSearchForApply}&typeOfProduct=${this.selectTypeOfProductForApply}`,
      ).then(({ data }) => {
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProductForApply[0].data.push(element);
        });
        this.filteredOptionsProductForApply = [
          {
            data: this.optionsProductForApply[0].data,
          },
        ];
        if (textSearch !== this.searchProductForApply) {
          let nextTextSearch = this.searchProductForApply;
          this.fetchProductForApply(nextTextSearch);
        }
      });
    },
    onSelectedProduct(option) {
      this.searchProductAccessory = '';

      let accessoryItems = {
        productId: option.item.productId,
        productName: option.item.productName,
        productCode: option.item.productCode,
        originalPrice: option.item.originalPrice,
        sellingPrice: option.item.sellingPrice,
        importPrice: 0,
      };

      this.accessoryItems.push(accessoryItems);
    },
    onInputChangeProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProductAccessory = text;
      this.debounceInput();
    },
    onSelectedProductFor(option) {
      this.searchProductFor = '';

      let accessoryProductItem = {
        productId: option.item.productId,
        productName: option.item.productName,
        productCode: option.item.productCode,
        originalPrice: option.item.originalPrice,
        sellingPrice: option.item.sellingPrice,
      };

      this.accessoryProductItems.push(accessoryProductItem);
    },

    onSelectedProductForApply(option) {
      this.searchProductForApply = '';

      const accessoryProductApplyItem = {
        id: 0,
        referenceId: option.item.id,
        name: option.item.name,
        code: option.item.code,
        type:
          this.selectTypeSearchForApply ===
          ACCESSORY_PRODUCT_SEARCH_TYPE.PRODUCT_CATEGORY
            ? ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
            : ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT,
        originalPrice: option.item.originalPrice,
        sellingPrice: option.item.sellingPrice,
        deleted: 0,
      };

      if (this.accessoryProductApplyItems.length > 0) {
        let isExist = this.accessoryProductApplyItems.some(
          (item) => item.referenceId === accessoryProductApplyItem.referenceId,
        );
        if (isExist) {
          this.makeToastFaile(
            'Sản phẩm/ nhóm sản phẩm đã tồn tại trong danh sách!',
          );
          return;
        }
      }
      this.accessoryProductApplyItems.push(accessoryProductApplyItem);
    },
    onInputChangeProductFor(text) {
      this.searchProductFor = text;

      this.debounceInputFor();
    },

    onInputChangeProductForApply(text) {
      this.searchProductForApply = text;

      this.debounceInputForApply();
    },

    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    onSubmit: function () {
      return this.withSubmitLock('save', () => this.doSubmit());
    },
    doSubmit: async function () {
      this.submitAttempted = true;
      if (!this.selectedCompanyId) {
        return this.makeToastFaile('Vui lòng chọn doanh nghiệp áp dụng!');
      }
      let isActive = 1;
      if (this.selectedStatus === 2) {
        isActive = 0;
      }
      this.accessoryItems.forEach((element) => {
        element.importPrice = unMaskPrice(element.importPrice);
      });
      let params = {
        name: this.name,
        code: this.code,
        companyIds: String(this.selectedCompanyId),
        description: this.description,
        //  bo phu kien kem theo
        type: 1,
        accessoryItems: this.accessoryItems,
        accessoryProductItems: this.accessoryProductItems,
        accessoryProductApplyItems: this.accessoryProductApplyItems.map(
          (item) => {
            if (
              item.type === ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
            ) {
              return {
                categoryId: item.referenceId,
              };
            }
            return {
              productId: item.referenceId,
            };
          },
        ),
        startDate: this.startDate
          ? moment(this.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        endDate: this.endDate
          ? moment(this.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        categories: this.selectedCategory,
        isActive: isActive,
      };

      ApiService.setHeader();
      return ApiService.post('accessories', { params })
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.$router.push({
              name: 'list-accessory',
              params: { createAccessorySuccess: true, message: 'Success' },
            });
          } else {
            this.makeToastFaile(message);
          }
        })
        .catch((error) => {
          // API trả 400 kèm COMPANY_REQUIRED / COMPANY_INVALID - không để lỗi rơi im lặng
          const message =
            (error.response && error.response.data.message) ||
            'Tạo bộ phụ kiện thất bại!';
          this.makeToastFaile(message);
        });
    },
    debounceInput: decounce(function () {
      if (!this.isSearching) {
        let textSearch = this.searchProductAccessory;
        this.fetchProduct(textSearch);
      }
    }, TIME_TRIGGER),
    debounceInputFor: decounce(function () {
      if (!this.isSearching) {
        let textSearch = this.searchProductFor;
        this.fetchProductFor(textSearch);
      }
    }, TIME_TRIGGER),
    debounceInputForApply: decounce(function () {
      if (!this.isSearching) {
        let textSearch = this.searchProductForApply;
        this.fetchProductForApply(textSearch);
      }
    }, TIME_TRIGGER),
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          this.excellist.map((element) => {
            let data = {
              productName: element['Tên sản phẩm']
                ? element['Tên sản phẩm']
                : '',
              productCode: element['Mã sản phẩm'] ? element['Mã sản phẩm'] : '',
              originalPrice: element['Giá vốn'] ? element['Giá vốn'] : 0,
              sellingPrice: element['Giá bán'] ? element['Giá bán'] : 0,
              returnPrice: element['Giá thu lại'] ? element['Giá thu lại'] : 0,
            };
            this.importItems.push(data);
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    showModalImportProduct() {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    hideModalImportProduct() {
      this.$refs['import-product-modal'].hide();
    },
    validData() {
      return this.withSubmitLock('importAccessory', () => this.doValidData());
    },
    doValidData() {
      let data = {
        listProduct: this.importItems,
      };
      ApiService.setHeader();
      return ApiService.post('accessories/valid-import-product', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.makeToastSuccess(message);
            response.data.data.forEach((element) => {
              this.accessoryItems.push(element);
            });
            this.hideModalImportProduct();
          } else {
            this.makeToastFailure(message);
          }
        })
        .catch((err) => {
          const message = err;
          this.makeToastFailure(message);
        });
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFailure(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    selectFileFor(event) {
      this.importItemFor = [];
      const files = event.target.files[0];
      this.fileFor = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.fileFor = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellistFor = excellist;
          this.excellistFor.map((element) => {
            let data = {
              productName: element['Tên sản phẩm']
                ? element['Tên sản phẩm']
                : '',
              productCode: element['Mã sản phẩm'] ? element['Mã sản phẩm'] : '',
              originalPrice: element['Giá vốn'] ? element['Giá vốn'] : 0,
              sellingPrice: element['Giá bán'] ? element['Giá bán'] : 0,
              returnPrice: element['Giá thu lại'] ? element['Giá thu lại'] : 0,
            };
            this.importItemFor.push(data);
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    showModalImportProductFor() {
      this.importItemFor = [];
      this.excellist = [];
      this.$refs['import-product-for-modal'].show();
    },
    hideModalImportProductFor() {
      this.$refs['import-product-for-modal'].hide();
    },

    showModalImportProductForApply() {
      this.importItemsForApply = [];
      this.excellist = [];
      this.$refs['import-product-for-apply-modal'].show();
    },
    hideModalImportProductForApply() {
      this.$refs['import-product-for-apply-modal'].hide();
    },
    selectFileForApply(event) {
      this.importItemsForApply = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          this.excellist.map((element) => {
            const data = {
              name: element['Tên'] ? element['Tên'] : '',
              code: element['Mã'] ? element['Mã'] : '',
              type:
                element['Loại'] === 'Nhóm sản phẩm'
                  ? ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT_CATEGORY
                  : ACCESSORY_PRODUCT_FOR_APPLY_TYPE.PRODUCT,
            };
            this.importItemsForApply.push(data);
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    validDataForApply() {
      return this.withSubmitLock('importForApply', () =>
        this.doValidDataForApply(),
      );
    },
    doValidDataForApply() {
      const data = {
        listProduct: this.importItemsForApply,
      };
      ApiService.setHeader();
      return ApiService.post('rewardProductCategory/valid-import-product', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.makeToastSuccess(message);
            response.data.data.forEach((element) => {
              if (
                this.accessoryProductApplyItems.find(
                  (item) => item.referenceId === element.referenceId,
                )
              ) {
                this.makeToastFailure(
                  `Sản phẩm/ nhóm sản phẩm ${element.name} đã tồn tại trong danh sách.`,
                );
                return;
              }
              this.accessoryProductApplyItems.push(element);
            });
            this.hideModalImportProductForApply();
          } else {
            this.makeToastFailure(message);
          }
        })
        .catch((err) => {
          const message = err;
          this.makeToastFailure(message);
        });
    },
    showDeleteProductApplyAlert: function (item) {
      Swal.fire({
        title: 'Xóa sản phẩm/ nhóm sản phẩm!',
        text: 'Bạn có chắc muốn xóa sản phẩm/ nhóm sản phẩm này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          this.accessoryProductApplyItems = _.reject(
            this.accessoryProductApplyItems,
            (product) => {
              return product.referenceId == item.referenceId;
            },
          );
        }
      });
    },

    validDataFor() {
      return this.withSubmitLock('importFor', () => this.doValidDataFor());
    },
    doValidDataFor() {
      let data = {
        listProduct: this.importItemFor,
      };
      ApiService.setHeader();
      return ApiService.post('accessories/valid-import-product', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.makeToastSuccess(message);
            response.data.data.forEach((element) => {
              this.accessoryProductItems.push(element);
            });
            this.hideModalImportProductFor();
          } else {
            this.makeToastFailure(message);
          }
        })
        .catch((err) => {
          const message = err;
          this.makeToastFailure(message);
        });
    },
    getInfoById: async function (id) {
      const STATUS_ACCESSORY_GROUP = {
        ACTIVE: 1,
        INACTIVE: 2,
      };
      await ApiService.setHeader();
      await this.fetchCompany();
      await ApiService.get('accessories/' + id).then((res) => {
        let {
          name,
          code,
          companyIds,
          description,
          startDate,
          endDate,
          accessoryItems,
          accessoryProductItems,
          isActive,
          accessoryCategories,
        } = res.data.data;
        this.name = name;
        this.code = code;
        // Luồng sao chép giữ pháp nhân của bản gốc (bản cũ nhiều pháp nhân lấy pháp nhân
        // đầu); danh sách tải lỗi thì để trống và chặn lưu, không tự đổi về DDV
        this.selectedCompanyId = pickProgramCompanyId(companyIds, this.companies);
        this.description = description;
        this.startDate =
          startDate !== null ? moment(startDate).format('DD/MM/YYYY') : '';
        this.endDate =
          endDate !== null ? moment(endDate).format('DD/MM/YYYY') : '';
        this.accessoryItems = accessoryItems;
        this.accessoryProductItems = accessoryProductItems;
        this.selectedStatus =
          isActive === STATUS_ACCESSORY_GROUP.ACTIVE
            ? STATUS_ACCESSORY_GROUP.ACTIVE
            : STATUS_ACCESSORY_GROUP.INACTIVE;
        this.selectedCategory = accessoryCategories;
      });
    },
  },
};
</script>

<style>
.rounded {
  border-radius: 0 !important;
}

.form-group label {
  font-weight: 600;
}
</style>
